import classNames from 'classnames';
import * as React from 'react';
import css from './styles.module.scss';

type Props = React.ComponentProps<'div'>;

export default function DesktopContainer(props: Props) {
  return <div {...props} className={classNames(props.className, css.container)} />;
}
